import api from '../config/axios';

export const getConsultancies = () => api.get('/consultancies');
export const getMyPortal = () => api.get('/consultancies/my');
export const createConsultancy = (data) => api.post('/consultancies', data);
export const updateConsultancy = (id, data) => api.put(`/consultancies/${id}`, data);
export const getConsultancyStudents = (id) => api.get(`/consultancies/${id}/students`);

export const updateStudentPayout = (studentId, data) => {
  const formData = new FormData();
  if (data.consultancyPayout !== undefined) formData.append('consultancyPayout', data.consultancyPayout);
  if (data.consultancyPayoutStatus) formData.append('consultancyPayoutStatus', data.consultancyPayoutStatus);
  if (data.consultancyPayoutDate) formData.append('consultancyPayoutDate', data.consultancyPayoutDate);
  if (data.receipt) formData.append('receipt', data.receipt);
  return api.put(`/consultancies/payout/${studentId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
